import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/mspr')({
    component: MsprConfiguration,
    staticData: {
        metadata: {
            title: 'Material service provider',
        },
        modules: ['mspr'],
        permissions: ['settings:update'],
        ui: {
            icon: Building2,
            widthVariant: 'default',
            title: 'Material service provider configuration',
            subtitle: 'Configure MSP register settings',
            menuDescription: 'Configure MSP register settings',
        },
    },
});

function MsprConfiguration() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'Definitions',
                        to: '/console/$orgId/configuration/compliance/mspr/definitions',
                    },
                    {
                        label: 'Governance',
                        to: '/console/$orgId/configuration/compliance/mspr/governance-config',
                    },
                    {
                        label: 'Critical operations',
                        to: '/console/$orgId/configuration/compliance/mspr/critical-operations',
                    },
                    {
                        label: 'Documents',
                        to: '/console/$orgId/configuration/compliance/mspr/documents',
                    },
                ]}
            />
        </PageController>
    );
}
